import { Clock, FileVideo, FileAudio, FileText } from "lucide-react";

const iconFor = (t) =>
  t === "video" ? <FileVideo className="w-3.5 h-3.5" /> :
  t === "audio" ? <FileAudio className="w-3.5 h-3.5" /> :
  <FileText className="w-3.5 h-3.5" />;

export default function HistorySidebar({ items, onSelect, activeId }) {
  return (
    <aside className="border border-zinc-800 bg-zinc-900/40" data-testid="history-sidebar">
      <div className="p-6 border-b border-zinc-800 flex items-center gap-2">
        <Clock className="w-4 h-4 text-zinc-500" />
        <span className="font-heading text-lg font-bold tracking-tight text-white">History</span>
        <span className="ml-auto text-[10px] font-mono uppercase tracking-widest text-zinc-500">
          {items.length}
        </span>
      </div>
      <div className="max-h-[620px] overflow-y-auto">
        {items.length === 0 && (
          <div className="p-6 text-sm text-zinc-500">No jobs yet. Generate your first subtitle.</div>
        )}
        {items.map((it) => (
          <button
            key={it.job_id}
            onClick={() => onSelect(it.job_id)}
            data-testid={`history-item-${it.job_id}`}
            className={`w-full text-left p-5 border-b border-zinc-800 hover:bg-zinc-800/60 transition-colors duration-200 ${activeId === it.job_id ? "bg-zinc-800/40" : ""}`}
          >
            <div className="flex items-center gap-2 text-[10px] font-mono uppercase tracking-widest text-zinc-500 mb-2">
              {iconFor(it.input_type)}
              <span>{it.input_type}</span>
              <span className="ml-auto">{new Date(it.created_at).toLocaleDateString()}</span>
            </div>
            <div className="text-sm text-white truncate">
              {it.filename || "Text input"}
            </div>
            <div data-testid={`history-language-${it.job_id}`} className="text-[11px] font-mono text-zinc-500 mt-1">
              {it.resolved_source_language || it.detected_language || it.source_language} → {it.target_language}
            </div>
          </button>
        ))}
      </div>
    </aside>
  );
}
